import { Typography } from "@mui/material"
import { Heading } from "shared/ui/list-page-heading"

export const MediaPlanningPage = () => {
  return (
    <Heading title="Медиапланирование" />
  )
}